export default {
    root: '/',
    fourNotFour:'/404',
    
}